interface ExternalVideoEmbedProps {
  platform: 'YOUTUBE' | 'VIMEO' | 'INSTAGRAM';
  externalUrl: string;
  oembedHtml?: string | null;
  className?: string;
}

function extractYouTubeId(url: string): string | null {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/
  );
  return match ? match[1] : null;
}

function extractVimeoId(url: string): string | null {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? match[1] : null;
}

export function ExternalVideoEmbed({
  platform,
  externalUrl,
  oembedHtml,
  className,
}: ExternalVideoEmbedProps) {
  const wrapperClass = className ?? 'w-full aspect-video rounded-lg overflow-hidden';

  if (platform === 'YOUTUBE') {
    const videoId = extractYouTubeId(externalUrl);
    if (!videoId) return <p className="text-muted-foreground">Invalid YouTube URL</p>;
    return (
      <div className={wrapperClass}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
    );
  }

  if (platform === 'VIMEO') {
    const videoId = extractVimeoId(externalUrl);
    if (!videoId) return <p className="text-muted-foreground">Invalid Vimeo URL</p>;
    return (
      <div className={wrapperClass}>
        <iframe
          src={`https://player.vimeo.com/video/${videoId}`}
          title="Vimeo video"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
    );
  }

  if (platform === 'INSTAGRAM' && oembedHtml) {
    return (
      <div
        className={wrapperClass}
        dangerouslySetInnerHTML={{ __html: oembedHtml }}
      />
    );
  }

  return (
    <a
      href={externalUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary underline"
    >
      View video on {platform.toLowerCase()}
    </a>
  );
}
